import { createSlice } from '@reduxjs/toolkit';

const initialState = { count: 0 };

export const errorBoundaryCounterSlice = createSlice({
  name: 'errorBoundaryCounter',
  initialState: initialState,
  reducers: {
    //here we will define all actions
    increment: (state) => {
      state.count += 1;
    },
    reset: (state) => {
      state.count = initialState.count;
    },
  },
});

export const { increment, reset } = errorBoundaryCounterSlice.actions;
export const errorBoundaryCounterReducer = errorBoundaryCounterSlice.reducer;
